/* eslint-disable */
const defaultOptions = {
    'type': 'serial',
    'theme': 'light',
    'marginTop': 0,
    'marginRight': 20,
    'marginLeft': 80,
    "valueAxes": [{
        "ignoreAxisWidth": true
    },],
    "startDuration": 0,
    "chartCursor": {
        "categoryBalloonEnabled": false
    },
    'dataDateFormat': 'YYYY-MM-DD HH:NN',
    'categoryField': 'timestamp',
    'categoryAxis': {
        'minPeriod': 'ss',
        'parseDates': true,
        'dateFormats': [
            { period: 'ss', format: 'JJ:NN:SS' },
            { period: 'mm', format: 'JJ:NN' },
            { period: 'hh', format: 'JJ:NN' },
            { period: 'DD', format: 'YYYY-MM-DD' },
            { period: 'WW', format: 'YYYY-MM-DD' },
            { period: 'MM', format: 'MMM' },
            { period: 'YYYY', format: 'YYYY' }],
    },
};

export default class GraphController {
    /* @ngInject */
    constructor($log, $rootScope, $translate, ThingsService, EventsService) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.ThingsService = ThingsService;
        this.EventsService = EventsService;
        this.dataProvider = [];
        this.charts = [];
    }

    $onChanges() {
        this.charts = [];

        // onChanges is triggered when bindings are changed
        this.getData();
    }

    getData() {
        const params = {
            thingId: this.thingId,
            fromDate: this.fromDate,
            toDate: this.toDate,
        };

        this.ThingsService.getRawObservations(params)
            .then((response) => {
                this.dataProvider = [];
                /* eslint-disable */

                let lastKnownPosition = '';

                for (let h of response.hits.hits) {
                    let k = h;
                    h = h._source.state;

                    let point = {
                        'timestamp': new Date(k._source.timestamp),
                    };

                    if (h.latlng && h.latlng.length > 0) {
                        lastKnownPosition = h.latlng;
                    }

                    if (h.mains_powered) {
                        point['power'] = h.mains_powered + 2;
                    }
                    if (h.mains_powered === 0) {
                        point['power'] = 0;
                    }

                    if (h.door_open) {
                        point['door'] = h.door_open + 1;
                    }
                    if (h.door_open === 0) {
                        point['door'] = 0;
                    }


                    if (this.showTransport === true) {
                        if (h.Virtual_In_Transport) {
                            point['in_transport'] = h.Virtual_In_Transport;
                        }
                        if (h.Virtual_In_Transport === 0) {
                            point['in_transport'] = 0;
                        }
                    } else {
                        if (h.moving) {
                            point['moving'] = h.moving;
                        }
                    }

                    if (h.box_temperature) point['box_temperature'] = h.box_temperature;
                    if (h.box_temperature) point['latlng'] = lastKnownPosition;
                    if (h.ambient_temperature) point['ambient_temperature'] = h.ambient_temperature;

                    this.dataProvider.push(point);
                }
            })
            .then(() => {
                params['sortOrder'] = 'asc';

                this.EventsService.getEvents(params)
                    .then((response) => {
                        for (let e of response.hits.hits) {
                            this.dataProvider.push({
                                'timestamp': new Date(e._source.timestamp),
                                'eventMessage': e._source.message,
                                'eventValue': 0
                                ,
                            });
                        }

                        // Having both temperature and events reading in the same array. Sort on the common property 'timestamp'
                        this.dataProvider.sort((a, b) => { return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0); });
                    })
                    .then(() => {
                        this.addTempChart();
                        this.addSensorChart();
                        this.setupSynchronization();
                        this.$rootScope.$emit('chartDataPrepared', this.dataProvider);
                    })
                    .catch((err) => {
                        this.$log.info(err);
                    });
            })
            .catch((error) => {
                this.$log.info(error);
            })

        // this.ThingsService.getObservations(params)
        //     .then((response) => {
        //         this.dataProvider = [];
        //         /* eslint-disable */

        //         let lastKnownPosition = '';
        //         let lastKnownDoor = undefined;
        //         let lastKnownPower = undefined;
        //         let lastKnownMoving = undefined;

        //         for (let h of response.aggregations.hist.buckets) {

        //             /*  Fill up data to make temperature and location always occur in pairs. This
        //                 because the temperature graph is clickable to show corresponding location */

        //             let point = {
        //                 'timestamp': new Date(h.key),
        //             };

        //             if (h.latlng.location && (h.latlng.location.lat > 0 && h.latlng.location.lon > 0)) {
        //                 lastKnownPosition = h.latlng.location.lat + ', ' + h.latlng.location.lon;
        //             }

        //             /*  "h.door.value", "h.power.value", "h.moving.value" can have 3 states: "1", "0" or "undefined".
        //                 "undefined" is not valid and will leave gaps in the graph.
        //             */

        //             if (h.door.value != undefined) lastKnownDoor = h.door.value + 2;
        //             if (h.power.value != undefined) lastKnownPower = h.power.value + 4;

        //             point['door'] = lastKnownDoor;
        //             point['power'] = lastKnownPower;
        //             if (h.moving.value === 1) point['moving'] = 1;

        //             if (h.box_temperature.value) point['box_temperature'] = h.box_temperature.value;
        //             if (h.box_temperature.value) point['latlng'] = lastKnownPosition;
        //             if (h.ambient_temperature.value) point['ambient_temperature'] = h.ambient_temperature.value;
        //             this.dataProvider.push(point);
        //         }
        //         /* eslint-enable */
        //     })
        //     .then(() => {
        //         params['sortOrder'] = 'asc';

        //         this.EventsService.getEvents(params)
        //             .then((response) => {
        //                 for (let e of response.hits.hits) {
        //                     this.dataProvider.push({
        //                         'timestamp': new Date(e._source.timestamp),
        //                         'eventMessage': e._source.message,
        //                         'eventValue': 0
        //                         ,
        //                     });
        //                 }

        //                 // Having both temperature and events reading in the same array. Sort on the common property 'timestamp'
        //                 this.dataProvider.sort((a, b) => { return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0); });
        //             })
        //             .then(() => {
        //                 this.addTempChart();
        //                 this.addSensorChart();
        //                 this.setupSynchronization();
        //                 this.$rootScope.$emit('chartDataPrepared', this.dataProvider);
        //             })
        //             .catch((err) => {
        //                 this.$log.info(err);
        //             });
        //     })
    }

    boxTemperatureBallonText(graphDataItem, graph) {
        return graphDataItem.dataContext.box_temperature + ' &#8451;';
    }

    ambientTemperatureBallonText(graphDataItem, graph) {
        return graphDataItem.dataContext.ambient_temperature + ' &#8451;';
    }

    eventMessageBallonText(graphDataItem, graph) {
        return graphDataItem.dataContext.eventMessage;
    }


    addTempChart() {
        const options = angular.merge({}, defaultOptions);
        options.dataProvider = this.dataProvider;
        options.legend = {
            'useGraphSettings': true,
            'equalWidths': false,
            'position': 'top',
        };

        options.graphs = [
            {
                'id': 'box_temp',
                'title': this.$translate.instant('IOF.COMPARTMENT.TEMPERATURE'),
                'balloonFunction': this.boxTemperatureBallonText,
                'bullet': 'round',
                'bulletSize': 6,
                'lineColor': '#ff9800',
                'lineThickness': 2,
                'type': 'line',
                'valueField': 'box_temperature',
                'valueAxis': 'temperatureAxis',
                'connect': true,
            },
            {
                'id': 'ambient_temp',
                'title': this.$translate.instant('IOF.COMPARTMENT2.TEMPERATURE'),
                'balloonFunction': this.ambientTemperatureBallonText,
                'bullet': 'round',
                'bulletSize': 6,
                'lineColor': '#1086ca',
                'lineThickness': 2,
                'type': 'line',
                'valueField': 'ambient_temperature',
                'valueAxis': 'temperatureAxis',
                'connect': true,
                'hidden': true,
            },
            {
                'id': 'event',
                'title': this.$translate.instant('NOTIFICATIONS.EVENT'),
                'balloonFunction': this.eventMessageBallonText,
                'bullet': 'triangleUp',
                'bulletSize': 16,
                'lineColor': '#ff0000',
                'type': 'line',
                'valueField': 'eventValue',
                'connect': false,
            }
        ];


        options.chartScrollbar = {
            'graph': 'box_temp',
            'gridAlpha': 0,
            'color': '#343434',
            'scrollbarHeight': 55,
            'backgroundAlpha': 0,
            'selectedBackgroundAlpha': 0.25,
            'selectedBackgroundColor': '#DEDEDE',
            'graphFillAlpha': 0,
            'selectedGraphFillAlpha': 0,
            'graphLineAlpha': 1,
            'graphLineColor': '#343434',
            'selectedGraphLineColor': '#343434',
            'selectedGraphLineAlpha': 1,
            'offset': 20,
        };

        options.export = {
            'enabled': true,
            'position': 'top-left',
            'offset': 40,
        };


        this.charts.push(AmCharts.makeChart('temp-chart', options));

        this.charts[0].addListener("clickGraphItem", (event) => {
            this.$rootScope.$emit('graphClicked', event.item.dataContext);
        });
    }

    powerBalloon(graphDataItem, graph) {
        const status = graphDataItem.dataContext.power === 3 ? this.$translate.instant('IOF.POWER_ON') : this.$translate.instant('IOF.POWER_OFF');
        return `<span style="font-size:14px;">${status}</span>`
    }

    doorBalloon(graphDataItem, graph) {
        const status = graphDataItem.dataContext.door === 2 ? this.$translate.instant('IOF.DOOR_OPEN') : this.$translate.instant('IOF.DOOR_CLOSED');
        return `<span style="font-size:14px;">${status}</span>`
    }

    movingBalloon(graphDataItem, graph) {
        let status = ''
        if (this.showTransport === false) {
            status = graphDataItem.dataContext.moving === 1 ? this.$translate.instant('IOF.MOVEMENT.MOVING') : this.$translate.instant('IOF.MOVEMENT.STILL');
        } else {
            status = graphDataItem.dataContext.in_transport === 1 ? 'In transport' : 'Not in transport';
        }
        return `<span style="font-size:14px;">${status}</span>`
    }

    addSensorChart() {
        const options = angular.merge({}, defaultOptions);
        options.dataProvider = this.dataProvider;
        options.valueAxes = [{ ignoreAxisWidth: true, labelsEnabled: false }];
        options.graphs = [
            {
                'id': 'door',
                'title': 'Door status',
                'balloonFunction': this.doorBalloon.bind(this),
                "balloon": {
                    "drop": false,
                    "adjustBorderColor": false,
                    "color": "#ffffff"
                },
                'lineColor': '#1086ca',
                'lineThickness': 2,
                'bullet': 'square',
                'bulletSize': 5,
                'type': 'step',
                'valueField': 'door',
            },
            {
                'id': 'power',
                'title': 'Power status',
                'balloonFunction': this.powerBalloon.bind(this),
                "balloon": {
                    "drop": false,
                    "adjustBorderColor": false,
                    "color": "#ffffff"
                },
                'lineColor': '#4CAF50',
                'lineThickness': 2,
                'bullet': 'square',
                'bulletSize': 5,
                'type': 'step',
                'valueField': 'power',
            },
            {
                'id': 'moving',
                'title': 'Movement status',
                'balloonFunction': this.movingBalloon.bind(this),
                "balloon": {
                    "drop": false,
                    "adjustBorderColor": false,
                    "color": "#ffffff"
                },
                'lineColor': '#343434',
                'lineThickness': 0,
                'type': 'line',
                'bullet': 'square',
                'bulletSize': 5,
                'valueField': 'moving',
            },
            {
                'id': 'in_transport',
                'title': 'Movement status',
                'balloonFunction': this.movingBalloon.bind(this),
                "balloon": {
                    "drop": false,
                    "adjustBorderColor": false,
                    "color": "#ffffff"
                },
                'lineColor': '#343434',
                'lineThickness': 2,
                'type': 'step',
                'bullet': 'square',
                'bulletSize': 5,
                'valueField': 'in_transport',
            },
        ];
        this.charts.push(AmCharts.makeChart('sensor-chart', options));
    }

    setupSynchronization() {
        // Synchronized scrolling based on this example:
        // https://www.amcharts.com/kbase/syncing-zoom-across-several-date-based-serial-charts/
        const charts = this.charts;
        const syncZoom = (event) => {
            for (x in charts) {
                if (charts[x].ignoreZoom) {
                    charts[x].ignoreZoom = false;
                }
                if (event.chart !== charts[x]) {
                    charts[x].ignoreZoom = true;
                    if ('zoomToDates' in charts[x]) {
                        charts[x].zoomToDates(event.startDate, event.endDate);
                    }
                }
            }
        }

        const handleCursorChange = (event) => {
            for (var x in charts) {
                if (event.chart !== charts[x]) {
                    charts[x].chartCursor.syncWithCursor(event.chart.chartCursor);
                    debugger;
                }
            }
        }

        const handleHideCursor = () => {
            for (var x in charts) {
                if (charts[x].chartCursor.hideCursor) {
                    charts[x].chartCursor.forceShow = false;
                    charts[x].chartCursor.hideCursor(false);
                }
            }
        }

        for (var x in charts) {
            charts[x].addListener('zoomed', syncZoom);
            charts[x].addListener("init", (event) => {
                event.chart.chartCursor.addListener('changed', handleCursorChange);
                event.chart.chartCursor.addListener('onHideCursor', handleHideCursor);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/detail/graph-component/graph.controller.js